import { render } from "./EditProductPage.vue?vue&type=template&id=cc3e691c&scoped=true&ts=true"
import script from "./EditProductPage.vue?vue&type=script&lang=ts"
export * from "./EditProductPage.vue?vue&type=script&lang=ts"

import "./EditProductPage.vue?vue&type=style&index=0&id=cc3e691c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc3e691c"]])

export default __exports__